import {
  isInsurer,
  isOwner,
  isBroker,
  isBrokerOrganisation,
} from '../auth/redux/authActions';
export const getReports = () => {
  if (isOwner()) {
    return [
      { label: 'Master MI', value: 'master_mi:bespoke' },
      { label: 'Management Information', value: 'mi:bespoke' },
      { label: 'Personal Accident MI', value: 'personal_accident_mi:bespoke' },
      { label: 'Smart Luggage MI', value: 'smart_luggage_mi:bespoke' },
      { label: 'Management Information Extended', value: 'extended_mi:bespoke' },
      { label: 'Marketing MI', value: 'marketing_mi:bespoke' },
      { label: 'Quotation Report', value: 'quotation:bespoke' },
      {
        label: 'Personal Accident Quotation Report',
        value: 'personal_accident_quotation:bespoke',
      },
      { label: 'Agent Bordereaux', value: 'bordereaux_agent:bespoke' },
      { label: 'ESF Bordereaux', value: 'bordereaux_esf:bespoke' },
      {
        label: 'Travel Dispute Bordereaux',
        value: 'bordereaux_travel_dispute:bespoke',
      },
      { label: 'Cash and Cheques', value: 'cash_and_cheques:bespoke' },
      { label: 'Cancellations', value: 'cancellations:bespoke' },
      { label: 'Marketing', value: 'marketing:bespoke' },
      { label: 'Marketing 2', value: 'marketing2:bespoke' },
      { label: 'Super Ticker', value: 'super_ticker:bespoke' },
      { label: 'Source Report', value: 'sources:bespoke' },
      { label: 'Ticker', value: 'ticker:bespoke' },
      { label: 'Team Stats', value: 'team_stats:bespoke' },
      { label: 'Incomplete Report', value: 'incomplete:bespoke' },
      { label: 'Marketing Incomplete Report', value: 'marketing_incomplete:bespoke' },
      {
        label: 'Personal Accident Incomplete Report',
        value: 'personal_accident_incomplete:bespoke',
      },
      { label: 'Electra', value: 'electra:bespoke' },
      { label: 'Broker Statement', value: 'broker_report:bespoke' },
      { label: 'Renewals', value: 'invited_renewal:bespoke' },
      { label: 'Renewing Policies', value: 'policies_renewal:bespoke' },
      { label: 'Lapsed Renewals', value: 'lapsed_renewal:bespoke' },
      { label: 'Failed Renewals', value: 'failed_renewal:bespoke' },
      { label: 'Active Policies', value: 'active_policies:bespoke' },
      { label: 'Signposted Quotes', value: 'signposted_quotes:bespoke' },
      { label: 'Signposted Policies', value: 'signposted_policies:bespoke' },
      {
        label: 'Personal Accident AIG Policy Master Record',
        value: 'aig_pa_master:bespoke',
      },
      {
        label: 'Personal Accident AIG Policy Individual Record',
        value: 'aig_pa_individual:bespoke',
      },
      { label: 'Personal Accident AIG Tag Along', value: 'aig_pa_tag_along:bespoke' },
      { label: 'Duplicate Customers', value: 'duplicate_customers:bespoke' },
    ];
  }

  if (isInsurer()) {
    return [
      { label: 'Management Information', value: 'mi:bespoke' },
      { label: 'Cancellations', value: 'cancellations:bespoke' },
    ];
  }
  if (isBroker() || isBrokerOrganisation()) {
    return [
      { label: 'Management Information', value: 'mi:bespoke' },
      { label: 'Quotation Report', value: 'quotation:bespoke' },
      { label: 'Source Report', value: 'sources:bespoke' },
      { label: 'Incomplete Report', value: 'incomplete:bespoke' },
      { label: 'Renewals', value: 'invited_renewal:bespoke' },
      { label: 'Renewing Policies', value: 'policies_renewal:bespoke' },
    ];
  }

  return [];
};
